FormData.prototype.toObject = function() {
  let object = {}
  for (let [key, value] of this)
    object[key] = value
  return object
}
